const CONTENT_IDS = {
  default: 'DEFAULT',
  basicInfo: 'BASIC_INFO',
  experience: 'EXPERIENCE',
  helpAddProject: 'HELP_ADD_PROJECT',
  helpBuild: 'HELP_BUILD',
  helpCertificationAward: 'HELP_CERTIFICATION_AWARD',
  helpFavoriteProject: 'HELP_FAVORITE_PROJECT',
  helpOutcome: 'HELP_OUTCOME',
  helpPublications: 'HELP_PUBLICATIONS',
  helpRole: 'HELP_ROLE',
  helpSummary: 'HELP_SUMMARY'
};

export default CONTENT_IDS;
